// Connecting a service that lets only desktop apps sign in (Upwork's MCP server, backend
// agents/mcp_connections.py "loopback"): the desktop app listens on 127.0.0.1 (desktop/src/loopback.js),
// BusyBee.Day starts the sign-in with that port, the person approves in their browser and the service
// comes back to the desktop app, which hands the code here to finish like any other sign-in.
import { desktop } from '../native/desktop';

/** Connect (or reconnect, with connectionId) a desktop-only service. Resolves to the connection. */
export async function connectInDesktop({ botId, catalogId, connectionId, sharing, projectId, doneText }) {
  const { botsApi } = await import('../services/api');  // loaded when used (pages and tests import this file)
  const { port } = await desktop.mcpLoopback({ done: doneText });
  const back = new Promise((resolve) => {
    const off = desktop.onMcpLoopback((result) => { off(); resolve(result || {}); });
  });
  const started = connectionId
    ? await botsApi.reconnect(connectionId, { loopback_port: port })
    : await botsApi.connect(botId, { catalog_id: catalogId, sharing, loopback_port: port,
      ...(projectId ? { project_id: projectId } : {}) });
  const { authorize_url: url, connection } = started.data;
  if (!url) return connection;  // signed in already
  desktop.openExternal(url);
  const { code, state, error } = await back;
  if (!code) throw new Error(error === 'access_denied' ? 'denied' : error || 'failed');
  return (await botsApi.finishConnect(state, code)).data;
}
